import { render, staticRenderFns } from "./Compliance.vue?vue&type=template&id=fada2676&scoped=true&"
import script from "./Compliance.vue?vue&type=script&lang=js&"
export * from "./Compliance.vue?vue&type=script&lang=js&"
import style0 from "./Compliance.vue?vue&type=style&index=0&id=fada2676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fada2676",
  null
  
)

export default component.exports